export default "__VITE_ASSET__BxDViYcO__"